exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".snippet em {\n  background-color: #efddac !important;\n  display: inline-block;\n  font-style: normal;\n  padding: 0 0.125rem;\n}", ""]);

// exports
